import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber, setSuffix } from '@/utils/helpers';
import { AdBundle } from '@/api/types/categories.types';
import { Typography } from '@/components/UI/Typography/Typography.styles';

type Props = {
  bundle: AdBundle;
};
export function BundleLabel({ bundle }: Props) {
  const { t, i18n } = useTranslation();

  const amount = t(setSuffix(i18n, bundle.count.toString(), 'common.n_ads'), {
    n: bundle.count.toString(),
  });

  const price = formatNumber(bundle.price, 2);
  const priceForOne = formatNumber(bundle.price / bundle.count, 2);

  return (
    <>
      {amount} / {price} AZN
      {bundle.count > 1 && (
        <Typography.Caption $variant="1" style={{ display: 'inline' }}>
          {' '}
          {t('pages.ad.price_for_one', { price: priceForOne })}
        </Typography.Caption>
      )}
    </>
  );
}
